import { UpgradeOnboardingModal } from './main';

export default UpgradeOnboardingModal;
